import * as React from "react";
const SvgIcFolderFilled = props => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M1 2H11L13 5H23V22H1V5V2Z" fill="currentColor" /></svg>;
export default SvgIcFolderFilled;